module.exports = __webpack_public_path__ + "img/swiper1.7f76ade0.jpg";